module.exports = __webpack_public_path__ + "media/npc_dota_hero_templar_assassin.84b4e991.webm";